import React from 'react';
import { motion, useInView } from 'framer-motion';

interface AnimationInitialProps {
  children: React.ReactNode;
}

export const AnimationInitial: React.FC<AnimationInitialProps> = ({
  children,
}) => {
  const ref = React.useRef(null);
  const isInView = useInView(ref);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0 }}
      animate={isInView ? { opacity: 1 } : ''}
      transition={{ duration: 0.75 }}
    >
      {children}
    </motion.div>
  );
};
